/**
 * University of South Florida (USF) tenant configuration
 */

import type { TenantConfig } from '../types'
import { defaultFeatures, defaultSupport } from './base'

const usfConfig: TenantConfig = {
  tenant: 'usf',

  branding: {
    name: 'University of South Florida',
    shortName: 'USF',
    logo: 'logos/usf-header.png',
    footerLogo: 'logos/usf-footer.png',
    favicon: 'favicon.ico',
    primaryColor: '#006747',    // USF Green
    secondaryColor: '#CFC493',  // USF Gold
    accentColors: [
      '#2C2C2C',  // Dark Gray
      '#F5F5F5',  // Light Gray
      '#004D36',  // Darker green
    ],
    theme: 'dark',              // Green header with white text
    heroImage: 'backgrounds/usf.jpg',
    headerText: '',
    // USF uses green for step indicator and interactive elements
    stepIndicatorColor: '#006747',
    interactiveAccentColor: '#006747',
  },

  features: {
    ...defaultFeatures,
    minorSelection: false,
    twoToFourYear: false,
    savedPlans: false,
  },

  dataSource: 'larx',

  institutions: {
    destination: {
      name: 'University of South Florida',
    },
    startingSchools: [
      {
        name: 'Hillsborough Community College',
        slug: 'hcc',
        enabled: true,
      },
    ],
  },

  support: {
    ...defaultSupport,
    contactEmail: 'transfer@usf.edu',
    helpUrl: 'https://www.usf.edu/admissions/transfer/',
  },

  content: {
    heroTitle: 'Transfer with Confidence',
    heroCTAText: 'Find Equivalencies',
    nav: {
      transferLabel: 'Transfer to USF',
    },
    footer: {
      addressLine: 'University of South Florida | 4202 E Fowler Ave, Tampa, FL 33620',
      contactLine: 'Phone: (813) 974-2011',
      copyrightLine: '© 2025 University of South Florida',
    },
  },
}

export default usfConfig
